import { render, staticRenderFns } from "./pc-download.vue?vue&type=template&id=50a80fee&scoped=true&"
import script from "./pc-download.vue?vue&type=script&lang=js&"
export * from "./pc-download.vue?vue&type=script&lang=js&"
import style0 from "./pc-download.vue?vue&type=style&index=0&id=50a80fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a80fee",
  null
  
)

component.options.__file = "pc-download.vue"
export default component.exports